import { ApiUrl } from './common/Config';
import { get } from './common/Helper';

const baseUrl = ApiUrl + 'coursetopic/';

export const getAllCourseTopics = async(token) => {
    let url = baseUrl + 'all';
    return await get(url, token);
};